document.addEventListener('DOMContentLoaded', () => {
 if (!window.location.pathname.includes('/cart')) return;

 async function updateState() {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  if (cart.item_count > 10) {
   document.body.classList.add('special-orders-required');
  } else {
   document.body.classList.remove('special-orders-required');
  }
 }

 // Estado inicial
 updateState();

 // Interceptar fetch SOLO cuando Shopify toca el carrito
 const originalFetch = window.fetch;
 window.fetch = function (...args) {
  const url = args[0]?.toString() || '';

  const isCartRequest =
   url.includes('/cart/add') ||
   url.includes('/cart/change') ||
   url.includes('/cart/update') ||
   url.includes('/cart.js');

  return originalFetch.apply(this, args).then(async (res) => {
   if (isCartRequest) {
    setTimeout(updateState, 300);
   }
   return res;
  });
 };
});



document.addEventListener('click', async (e) => {
 const checkoutBtn = e.target.closest('[name="checkout"], [href*="/checkout"]');
 if (!checkoutBtn) return;

 e.preventDefault();

 const res = await fetch('/cart.js');
 const cart = await res.json();

 if (cart.item_count > 10) {
  window.location.href = '/pages/special-orders';
 } else {
  window.location.href = '/checkout';
 }
});
